<template>
  <div class="max-[481px]:p-5">
    <div class="title text-[#1F1D1F] self-stretch lg:p-[20px] pb-[20px]">
      ข่าวประชาสัมพันธ์
    </div>
    <div
      v-if="newsData.length <= 0 || disasters.length == 0"
      class="flex w-full h-[200px] p-10 px-5 flex-col justify-center items-center gap-[9px] self-stretch"
    >
      <!-- <PeopleIcon /> -->
      <div class="">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="62"
          height="62"
          viewBox="0 0 62 62"
          fill="none"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M38.9995 48.7827C41.2482 46.8854 44.153 45.7419 47.3249 45.7419C53.751 45.7419 59.0795 50.4307 60.0797 56.5724C60.1066 56.7476 60.0556 56.926 59.9401 57.0604C59.8246 57.195 59.6562 57.2724 59.4788 57.2724C57.413 57.2724 51.0811 57.2724 45.307 57.2719C44.3077 53.7286 42.0284 50.7216 38.9995 48.7827ZM47.3249 44.5262C43.7272 44.5262 40.7946 41.5902 40.7946 37.9925C40.7946 34.3948 43.7272 31.4588 47.3249 31.4588C50.926 31.4588 53.8586 34.3948 53.8586 37.9925C53.8586 41.5902 50.926 44.5262 47.3249 44.5262ZM16.6862 57.2722C10.9117 57.2719 4.57856 57.2715 2.51202 57.2702C2.33525 57.2702 2.16737 57.1931 2.05224 57.059C1.93724 56.9248 1.88642 56.7471 1.91329 56.5724C2.91465 50.4306 8.24288 45.7419 14.6656 45.7419C17.8391 45.7419 20.7449 46.8854 22.9938 48.7826C19.9655 50.7215 17.6861 53.7286 16.6862 57.2722ZM14.6656 44.5262C11.068 44.5262 8.13542 41.5902 8.13542 37.9925C8.13542 34.3948 11.068 31.4588 14.6656 31.4588C18.2668 31.4588 21.1993 34.3948 21.1993 37.9925C21.1993 41.5902 18.2668 44.5262 14.6656 44.5262ZM40.5793 16.1791V10.5553C41.6443 11.0434 42.3841 12.1189 42.3841 13.3672C42.3841 14.6155 41.6443 15.691 40.5793 16.1791ZM19.7639 20.407H23.5024H23.5027C23.5509 20.4155 23.5991 20.4241 23.6471 20.4329V28.2534H22.64C21.0569 28.2534 19.7639 26.9604 19.7639 25.3773V20.407ZM32.9026 22.2587C30.5366 20.9156 28.0363 19.7378 25.3132 19.0541C25.3368 18.9415 25.349 18.8247 25.349 18.705V8.23664C25.349 8.09234 25.3312 7.95229 25.2974 7.81856C27.9572 7.02363 30.52 5.69756 32.9026 4.35362V22.2587ZM38.8773 23.0607C38.8773 23.6575 38.5747 24.1672 38.0526 24.4532C37.5305 24.7391 36.942 24.7226 36.4363 24.4034C35.8313 24.0221 35.2221 23.6367 34.6045 23.2596V3.37949C35.2552 3.00238 35.8934 2.63767 36.5069 2.2895C37.0166 2.00357 37.5885 2.00771 38.0899 2.30202C38.5914 2.59622 38.8773 3.09356 38.8773 3.67368V23.0607ZM23.6471 18.705H18.1477C15.2674 18.705 12.9134 16.347 12.9134 13.4708C12.9134 10.5947 15.2674 8.23664 18.1477 8.23664H23.6471V18.705ZM44.6708 8.96982C44.2913 9.34948 43.6749 9.34948 43.2954 8.96982C42.9158 8.59028 42.9158 7.97405 43.2954 7.59451L45.4131 5.47679C45.7926 5.09725 46.409 5.09725 46.7885 5.47679C47.1681 5.85632 47.1681 6.47256 46.7885 6.85209L44.6708 8.96982ZM43.274 19.1599C42.8948 18.78 42.8954 18.1638 43.2753 17.7846C43.6552 17.4055 44.2716 17.406 44.6507 17.786L46.7685 19.9078C47.1476 20.2877 47.147 20.904 46.7671 21.2831C46.3872 21.6623 45.7709 21.6618 45.3917 21.2818L43.274 19.1599ZM46.0801 14.3563C45.5433 14.3563 45.1076 13.9206 45.1076 13.3837C45.1076 12.847 45.5433 12.4112 46.0801 12.4112H49.0806C49.6173 12.4112 50.0531 12.847 50.0531 13.3837C50.0531 13.9206 49.6173 14.3563 49.0806 14.3563H46.0801ZM18.243 59.2219C19.2444 53.08 24.5725 48.3914 30.9953 48.3914C37.4214 48.3914 42.7499 53.0801 43.75 59.2219C43.777 59.3971 43.726 59.5754 43.6105 59.7099C43.495 59.8445 43.3265 59.9219 43.1492 59.9219C39.4955 59.9219 22.4963 59.9219 18.8416 59.9197C18.665 59.9197 18.497 59.8425 18.3819 59.7084C18.2668 59.5742 18.2161 59.3966 18.243 59.2219ZM30.9953 47.1757C27.3976 47.1757 24.465 44.2397 24.465 40.642C24.465 37.0443 27.3976 34.1083 30.9953 34.1083C34.5964 34.1083 37.529 37.0443 37.529 40.642C37.529 44.2397 34.5964 47.1757 30.9953 47.1757Z"
            fill="#9B237B"
          />
        </svg>
      </div>
      <div class="label text-[#7C7379] mt-[9px]">ขณะนี้ยังไม่มีข่าวประชาสัมพันธ์</div>
      <div class="flex justify-center mt-[20px] max-[1041px]:hidden">
        <button
          class="w-[98px] h-[50px] M flex items-center justify-center rounded-[6px] border border-[#B7B2B5] bg-[#FFF] text-[#1F1D1F] 
          disabled:text-[#DFDCDD] disabled:border-none max-[481px]:border"
          @click="$router.push('/public-relations-news')"
          :disabled="newsData.length <= 0 || disasters.length == 0"
        >
          อ่านทั้งหมด
        </button>
      </div>
      <div class="flex justify-center mt-[20px] min-[1041px]:hidden">
        <button
          class="w-[98px] h-[50px] M flex items-center justify-center rounded-[6px] border border-[#B7B2B5] bg-white text-[#1F1D1F] 
          disabled:text-[#DFDCDD] max-[481px]:border"
          @click="$router.push('/public-relations-news')"
          :disabled="newsData.length <= 0 || disasters.length == 0"
        >
          อ่านทั้งหมด
        </button>
      </div>
    </div>
    <div v-else>
      <div class="min-h-[200px] rounded-[10px] lg:p-[20px]">
        <!-- Header -->
        <!-- <div class="title text-[#1F1D1F] self-stretch">ข่าวประชาสัมพันธ์</div> -->
        <div
          class="flex flex-col md:flex-row justify-between items-start md:items-center w-full"
        >
          <div class="w-full pb-[0px]">
            <div class="relative">
              <!-- Grid container with responsive classes -->
              <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[20px]">
                <div
                  v-for="item in cards"
                  :key="item.id"
                  class="border border-[#B7B2B5] bg-white rounded-[8px] px-[8px] pt-[8px] pb-[14px] flex flex-col min-h-[369px]"
                >
                  <img
                    :src="`${item.image}`"
                    alt="Card Image"
                    class="h-[230px] w-full object-cover border border-[#B7B2B5]"
                  />
                  <div
                    class="title-14 text-[#1F1D1F] flex flex-col items-start my-[6px] self-stretch flex-grow multi-line-ellipsis"
                  >
                    {{ item.title }}
                  </div>
                  <div
                    class="flex justify-between items-center sm:items-center sm:flex-row self-stretch"
                  >
                    <div
                      class="label !text-[13px] text-[#FFF] bg-[#9B237B] flex items-center justify-center self-stretch w-[106px] min-w-[106px] max-w-[230px] px-[3px] py-[1.5px] text-center text-sm"
                    >
                      {{ item.thai_created_at }}
                    </div>
                    <button
                      class="w-[70px] h-[42px] s flex items-center justify-center rounded-[6px] text-[#1F1D1F] border border-[#B7B2B5] bg-white"
                      @click="goToNews(item)"
                    >
                      อ่านต่อ
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex justify-center mt-[20px]">
              <button
                class="w-[98px] h-[50px] M flex items-center justify-center rounded-[6px] border border-[#B7B2B5] bg-white text-[#1F1D1F]"
                @click="$router.push('/public-relations-news')"
                :disabled="newsData.length <= 0 || disasters.length == 0"
              >
                อ่านทั้งหมด
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { useNewsStore } from "@/pinia/news";
import { useDisaterRequestStore } from "@/pinia/disater";

const NewsStore = useNewsStore();

const router = useRouter();
const disaterStore = useDisaterRequestStore();

const newsData = ref([{ id: 1 }]);

const cards = ref([]);
const disasters = ref([]);

// computed
const displayedCards = computed(() => cards.value.slice(0, 4));

// methods
function goToNews(data) {
  localStorage.setItem("newID", JSON.stringify(data));
  localStorage.setItem("inShelter", false);
  router.push(`/public-relations-news/${data.title}`);
}

async function getNews() {
  const s = await NewsStore.getNews({ limit: 4 });
  cards.value = s.data.data;
  // console.log("news", cards.value);
}

async function getDiasaterWithFiltersRaw() {
  // กรองคีย์ที่เป็น undefined ออก
  const params = {};
  // ถ้า sort ไม่มีค่า → ใส่ desc ไปเลย
  params.sort = "desc";

  // เรียกของจริง
  const s = await disaterStore.getDiasater(params);
  disasters.value = s.data.data;
  // console.log("fwfwfw");
}

onMounted(async () => {
  await getNews();
  await getDiasaterWithFiltersRaw();
});
</script>

<style scoped>
.multi-line-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  /* word-break: break-word !important; */
  /* overflow-wrap: anywhere !important; */
}
</style>
